export default __webpack_public_path__ + "9f629051c004ea09db12596096fdab9f.png";